import { Injectable } from '@angular/core';
import { EnvironmentDefinition } from './environment-definition';
import { Environments } from './Environments';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  public currentEnvironment:EnvironmentDefinition;

  constructor()
  {       
      this.currentEnvironment = this.getValidEnvironment();
      console.log("Current environment: " + this.currentEnvironment.name +" : API :" + this.currentEnvironment.apiUrl);
  }

  private getValidEnvironment(): EnvironmentDefinition {
       return this.determineEnvironmentFromPath();
  }

  private determineEnvironmentFromPath(): EnvironmentDefinition {
      var path = window.location.host.toUpperCase();
      return this.determineEnvironmentFromHost(path);
  }

  private determineEnvironmentFromHost(host: string): EnvironmentDefinition {
      for (var i = 0; i < this.environments.length; i++) {
          var env = this.environments[i];
          for (var j = 0; j < env.host.length; j++) {
              var envHost = env.host[j].trim().toUpperCase();
              if (host.indexOf(envHost) !== -1) {
                  return env;
              }
          }
      }
      //return 'PROD';
  }

  private environments:EnvironmentDefinition[] = Environments.environments;
}
